import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';

@Component({
  selector: 'bhub-my-tables-page',
  templateUrl: './my-tables-page.component.html',
  styleUrls: ['./my-tables-page.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class MyTablesPageComponent extends BasePageComponent implements OnInit {
  selectedTabIndex = 0;

  constructor() {
    super();
  }

  ngOnInit() {
    // Initialize component
  }
}
